import Moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import EDatepickerRange from '../../../elements/components/datepicker/types/range'

const propTypes = {
    items: PropTypes.array,
    materials: PropTypes.array,
    actions: PropTypes.array,

    filters: PropTypes.object,
    filtersAPI: PropTypes.object,
    tabs: PropTypes.object,
    tab: PropTypes.string,
    lastRefresh: PropTypes.string,
    userName: PropTypes.string,
    onFilterChange: PropTypes.func,
    onFilterAPIChange: PropTypes.func,
    onClickLoadData: PropTypes.func,
    onClickLogout: PropTypes.func
}

const defaultProps = {
    items: [],
    materials: [],
    actions: [],

    filters: {},
    filtersAPI: {},
    tabs: {},
    tab: '',
    lastRefresh: '',
    userName: ''
}

class OverviewFilter extends Component {
    render() {

        const datesInputPlaceholder = function () {
            let placeholder = ''
            if (!this.props.filtersAPI.term || !this.props.filtersAPI.term.length) {
                const range = getMinMaxDates(this.props.items)
                if (range.every(date => Moment(date).isValid())) {
                    placeholder = `${Moment(range[0]).format('DD.MM.YYYY')} - ${Moment(range[1]).format('DD.MM.YYYY')}`
                }
            }
            return placeholder
        }.bind(this)()

        //const getMinHeight = function () {
        //    return (window.innerHeight - 53)+"px";
        //}
        //style = {{ minHeight: getMinHeight() }}

        return (
            <div className="card">
                <div className="card-body">

                    <div className="text-center px-xl-3">
                        <button
                            className="btn btn-primary btn-block"
                            type="button"
                            title={this.props.userName}
                            onClick={this.props.onClickLogout}><i className="fa fa-sign-out"></i> Odhlášení</button>
                    </div>

                    <hr className="my-3" />

                    <div className="row">

                        <div className="col-md-12">

                            <div className="row">

                                <div className="col-md-4 text-center">
                                    <div className="form-group custom-control custom-radio">
                                        <input
                                            type="radio"
                                            className="custom-control-input"
                                            name="type_1"
                                            checked={this.props.filtersAPI.type === 1}
                                            onChange={(e) => this.props.onFilterAPIChange('type', 1)}
                                            id="type_1"
                                            title="Typ-zobrazení = 1" />
                                        <label className="custom-control-label" htmlFor="type_1" title="Typ-zobrazení = 1">jen aktivní</label>
                                    </div>
                                </div>

                                <div className="col-md-4 text-center">
                                    <div className="custom-control custom-radio">
                                        <input
                                            type="radio"
                                            className="custom-control-input"
                                            name="type_2"
                                            checked={this.props.filtersAPI.type === 2}
                                            onChange={(e) => this.props.onFilterAPIChange('type', 2)}
                                            id="type_2"
                                            title="Typ-zobrazení = 2" />
                                        <label className="custom-control-label" htmlFor="type_2" title="Typ-zobrazení = 2">za období</label>
                                    </div>
                                </div>

                                <div className="col-md-4 text-center">
                                    <div className="form-group custom-control custom-radio">
                                        <input
                                            type="radio"
                                            className="custom-control-input"
                                            name="type_3"
                                            checked={this.props.filtersAPI.type === 3}
                                            onChange={(e) => this.props.onFilterAPIChange('type', 3)}
                                            id="type_3"
                                            title="Typ-zobrazení = 3" />
                                        <label className="custom-control-label" htmlFor="type_3" title="Typ-zobrazení = 3">potvrzené</label>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="col-md-12" hidden={this.props.filtersAPI.type === 1}>
                            <EDatepickerRange
                                value={this.props.filtersAPI.term}
                                onChange={(value) => this.props.onFilterAPIChange('term', value)}
                                placeholder={datesInputPlaceholder}
                                title="Zadej období" />
                        </div>

                        <div className="col-md-12" hidden={this.props.filtersAPI.type === 1}>
                            <hr className="my-3" />
                        </div>

                    </div>


                    <div className="form-group">
                        <label>Číslo zakázky</label>
                        <div>
                            <input
                                className="form-control w-100"
                                type="text"
                                value={this.props.filters.CISLOZAKAZKY}
                                onChange={(e) => this.props.onFilterChange('CISLOZAKAZKY', e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Název zakázky</label>
                        <div>
                            <input
                                className="form-control w-100"
                                type="text"
                                value={this.props.filters.PRIJMENI}
                                onChange={(e) => this.props.onFilterChange('PRIJMENI', e.target.value)} />
                        </div>
                    </div>

                    <div className="form-group">

                        <label>Materiál</label>
                        {this.props.materials.map((material) =>
                            <div className="px-2" key={material.key}>
                                <div className="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        className="custom-control-input"
                                        name={material.key}
                                        checked={this.props.filters.LAKOVNA_TYP_MATERIALU_ID === material.LAKOVNA_TYP_MATERIALU_ID}
                                        onChange={(e) => this.props.onFilterChange('LAKOVNA_TYP_MATERIALU_ID', material.LAKOVNA_TYP_MATERIALU_ID)}
                                        id={material.key} />
                                    <label className="custom-control-label" htmlFor={material.key}>{material.POPIS}</label>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="form-group">

                        <label>Akce</label>
                        {this.props.actions.map((action) =>
                            <div className="px-2" key={action.key}>
                                <div className="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        className="custom-control-input"
                                        name={action.key}
                                        checked={this.props.filters.LAKOVNA_AKCE_ID === action.LAKOVNA_AKCE_ID}
                                        onChange={(e) => this.props.onFilterChange('LAKOVNA_AKCE_ID', action.LAKOVNA_AKCE_ID)}
                                        id={action.key} />
                                    <label className="custom-control-label" htmlFor={action.key}>{action.POPIS}</label>
                                </div>
                            </div>
                        )}

                    </div>

                    <small className="pull-right">last-refresh {this.props.lastRefresh}</small>
                </div>
            </div>
        )
    }


}

OverviewFilter.propTypes = propTypes
OverviewFilter.defaultProps = defaultProps

function getMinMaxDates(items) {
    let min = Number.POSITIVE_INFINITY,
        max = 0;
    items.forEach(item => {
        if (item.term < min) {
            min = item.term
        }
        if (item.term > max) {
            max = item.term
        }
    })
    return [Moment(min).toDate(), Moment(max).toDate()];
}

export default OverviewFilter



